const bankNames = {
  '105': 'AIK BANKA, AD, BEOGRAD',
  '115': 'MOBI BANKA, AD, BEOGRAD',
  '145': 'EXPOBANK, AD, BEOGRAD',
  '150': 'DIREKTNA BANKA, AD, KRAGUJEVAC',
  '155': 'HALKBANK, AD, BEOGRAD',
  '160': 'BANCA INTESA, AD, BEOGRAD',
  '165': 'ADDIKO BANK, AD, BEOGRAD',
  '170': 'UNICREDIT BANK SRBIJA, AD, BEOGRAD',
  '190': 'JUBMES BANKA, AD, BEOGRAD',
  '200': 'BANKA POŠTANSKA ŠTEDIONICA, AD, BEOGRAD',
  '205': 'KOMERCIJALNA BANKA , AD, BEOGRAD',
  '220': 'PROCREDIT BANK, AD, BEOGRAD',
  '250': 'EUROBANK, AD, BEOGRAD',
  '265': 'RAIFFEISEN BANKA, AD, BEOGRAD',
  '275': 'OTP BANKA SRBIJA, AD, BEOGRAD',
  '285': 'SBERBANK SRBIJA, AD, BEOGRAD',
  '295': 'SRPSKA BANKA, AD, BEOGRAD',
  '310': 'NLB BANKA, AD, BEOGRAD',
  '325': 'VOJVOĐANSKA BANKA, AD, NOVI SAD',
  '330': 'CREDIT AGRICOLE BANKA SRBIJA, AD, NOVI SAD',
  '340': 'ERSTE BANK, AD, NOVI SAD',
  '360': 'MTS BANKA, AD, BEOGRAD',
  '370': 'OPPORTUNITY BANKA, AD, NOVI SAD',
  '375': 'API BANK, AD, BEOGRAD',
  '380': 'MIRABANK, AD, BEOGRAD',
  '385': ' BANK OF CHINA SRBIJA, AD, BEOGRAD – NOVI BEOGRAD'
};
const cyrillicToLatinAlphabet = {
  А: 'A',
  Б: 'B',
  В: 'V',
  Г: 'G',
  Д: 'D',
  Ђ: 'Đ',
  Е: 'E',
  Ж: 'Ž',
  З: 'Z',
  И: 'I',
  Ј: 'J',
  К: 'K',
  Л: 'L',
  Љ: 'Lj',
  М: 'M',
  Н: 'N',
  Њ: 'Nj',
  О: 'O',
  П: 'P',
  Р: 'R',
  С: 'S',
  Т: 'T',
  Ћ: 'Ć',
  У: 'U',
  Ф: 'F',
  Х: 'H',
  Ц: 'C',
  Ч: 'Č',
  Џ: 'Dž',
  Ш: 'Š'
};

const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

export const TicketReplyType = {
  COMMENT: 'comment',
  REPLY: 'contractor_reply',
  LOG: 'system_log',
  SENT_TO_CONTRACTOR: 'sent_to_contractor_system_log'
};

export const UserRoles = {
  MANAGER: 'MANAGER',
  SUPER_MANAGER: 'SUPER_MANAGER'
};

export const utilService = {
  formatDate(isoDate) {
    if (isoDate == null) return '/';
    let date = new Date(isoDate).toISOString();
    let rawDate = date.split('T')[0].split('-');

    date = `${rawDate[2]}.${rawDate[1]}.${rawDate[0]}.`;
    return date;
  },
  getBankNameByCode(code) {
    const name = bankNames[code];
    if (name) {
      return name;
    } else {
      return '';
    }
  },
  isEmailValid(email) {
    return email == '' ? '' : reg.test(email) ? true : false;
  },
  convertCyrillicToLatin(word) {
    return word
      .split('')
      .map(function(char) {
        if (char == char.toUpperCase()) {
          return cyrillicToLatinAlphabet[char.toUpperCase()] || char;
        } else {
          return (
            cyrillicToLatinAlphabet[char.toUpperCase()] || char
          ).toLowerCase();
        }
      })
      .join('');
  }
};
